import moment from "moment";

/**
 * DUMMY DATA — matches your real API mapping exactly.
 *
 * `data` (goes into transformGPSData):
 *   An array of PAIRS. Each pair is [pointA, pointB]:
 *     pointA.isLocationDetectedTime  -> start of the segment (ISO/UTC string)
 *     pointB.isLocationDetectedTime  -> end of the segment (ISO/UTC string)
 *     pointA.isLocationDetected      -> true/false
 *     pointA.gpsLostReason           -> "GPS_OFF" | "NORMAL_LOST" | "INTERNET_OFF"
 *   This is exactly what transformGPSData reads via:
 *     pair[0]?.isLocationDetectedTime, pair[1]?.isLocationDetectedTime,
 *     pair[0]?.isLocationDetected,
 *     pair[0]?.gpsLostReason ?? pair[1]?.gpsLostReason
 *
 * `time` (used directly by the dialog for the overall START/END markers):
 *   An array of { startTime, endTime } where both are already moment
 *   objects (the dialog calls .format(...) on them directly, with no
 *   moment.utc()/.local() conversion) — so pass real moment instances,
 *   not raw strings, here.
 */

// Change this to "today" if you want the demo to always show today's date
const DAY = "2024-06-10";

const utc = (hhmm) => `${DAY}T${hhmm}:00.000Z`;

export const dummyGpsData = [
  // 08:15 - 08:40  GPS turned off
  [
    { isLocationDetectedTime: utc("08:15"), isLocationDetected: false, gpsLostReason: "GPS_OFF" },
    { isLocationDetectedTime: utc("08:40") },
  ],
  // 09:05 - 09:20  Normal GPS lost
  [
    { isLocationDetectedTime: utc("09:05"), isLocationDetected: false, gpsLostReason: "NORMAL_LOST" },
    { isLocationDetectedTime: utc("09:20") },
  ],
  // 10:00 - 10:12  Internet off
  [
    { isLocationDetectedTime: utc("10:00"), isLocationDetected: false, gpsLostReason: "INTERNET_OFF" },
    { isLocationDetectedTime: utc("10:12") },
  ],
  // 11:30 - 12:05  GPS turned off
  [
    { isLocationDetectedTime: utc("11:30"), isLocationDetected: false, gpsLostReason: "GPS_OFF" },
    { isLocationDetectedTime: utc("12:05") },
  ],
  // 13:00 - 13:18  Normal GPS lost
  [
    { isLocationDetectedTime: utc("13:00"), isLocationDetected: false, gpsLostReason: "NORMAL_LOST" },
    { isLocationDetectedTime: utc("13:18") },
  ],
  // 14:10 - 14:25  Internet off
  [
    { isLocationDetectedTime: utc("14:10"), isLocationDetected: false, gpsLostReason: "INTERNET_OFF" },
    { isLocationDetectedTime: utc("14:25") },
  ],
  // 15:45 - 16:20  GPS turned off
  [
    { isLocationDetectedTime: utc("15:45"), isLocationDetected: false, gpsLostReason: "GPS_OFF" },
    { isLocationDetectedTime: utc("16:20") },
  ],
  // 16:50 - 17:05  Normal GPS lost
  [
    { isLocationDetectedTime: utc("16:50"), isLocationDetected: false, gpsLostReason: "NORMAL_LOST" },
    { isLocationDetectedTime: utc("17:05") },
  ],
  // 17:30 - 17:48  Internet off
  [
    { isLocationDetectedTime: utc("17:30"), isLocationDetected: false, gpsLostReason: "INTERNET_OFF" },
    { isLocationDetectedTime: utc("17:48") },
  ],
];

// Overall tracked window for the day — drives the START / END nodes
export const dummyGpsTime = [
  {
    startTime: moment(`${DAY}T08:00:00`),
    endTime: moment(`${DAY}T18:00:00`),
  },
];